import { REPORT_COLORS } from '../../constants';
import './BandBars.css';

export interface Band {
  label: string;
  value: number;
  /** Rendered at the end of the bar; falls back to the raw value. */
  display?: string;
  context?: string;
}

interface BandBarsProps {
  bands: Band[];
  /** Names the single series, so no legend box is needed. */
  caption: string;
  color?: string;
}

/**
 * Single-series magnitude bars. Values are direct-labelled rather than read off
 * an axis, and the underlying numbers stay available as a table for screen
 * readers and for anyone who cannot separate the marks visually.
 */
export function BandBars({ bands, caption, color = REPORT_COLORS.magnitude }: BandBarsProps) {
  const max = Math.max(...bands.map((b) => b.value), 0);

  return (
    <figure className="BandBars">
      <figcaption className="BandBars-caption">{caption}</figcaption>
      <table className="BandBars-table">
        <tbody>
          {bands.map((b) => (
            <tr className="BandBars-row" key={b.label}>
              <th scope="row" className="BandBars-label">{b.label}</th>
              <td className="BandBars-track">
                <div
                  className="BandBars-bar"
                  style={{
                    width: max > 0 ? `${Math.max((100 * b.value) / max, 0.6)}%` : '0%',
                    background: color,
                  }}
                  title={`${b.label}: ${b.display ?? b.value}`}
                />
              </td>
              <td className="BandBars-value">{b.display ?? b.value}</td>
              <td className="BandBars-context">{b.context ?? ''}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </figure>
  );
}
